import { useSyncExternalStore } from "react"
import { Editor } from "@/core/editor"
import { useEditor } from "@/utils/useEditor"

const getViewportStateHash = (editor: Editor) => {
	return editor.mainViewport.cropViewMatrix.join()
}

export const useObserveEditorViewport = () => {
	const editor = useEditor()

	return useSyncExternalStore(
		(onStoreChange) => {
			return editor.events.subscribe((event) => {
				if (event.type === "render") {
					onStoreChange()
				}
			})
		},
		() => {
			return getViewportStateHash(editor)
		},
	)
}
